<script setup>
import PdfViewer from "../../../../assets/components/PdfViewer.vue";
import DistanceAllowance from "../DistanceAllowance.vue";

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(["accept", "deny", "fix"])
</script>

<template>
  <span id="invoice_details_body">
    <PdfViewer :url="props.data.receipt_url" v-if="props.data.receipt_url !== ''" :docPath="props.data.document_filename" />
    <DistanceAllowance v-else :invoice="props.data" />
  </span>
</template>
